<template>
  <el-dialog
    title="协议信息"
    :visible.sync="isShow"
    @close='closeDetail'
    width="1200px"
    :close-on-click-modal="false">
    <ProtocolDetail :protocolId="protocolId"></ProtocolDetail>
  </el-dialog>
</template>

<script>
import ProtocolDetail from "@/pages/protocol/manage/ProtocolDetail";
export default {
  components:{
    ProtocolDetail
  },
  props:{
    protocolId: String,
    dialogVisible: false
  },
  data () {
    return {
      isShow: this.dialogVisible,
    }
  },
  watch: {
    dialogVisible () {
      this.isShow = this.dialogVisible;
    },
  },
  methods:{
    closeDetail(){
      this.$emit("update:dialogVisible", false);
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/child/view/ProtocolDetailDialog.vue